import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import type {
  FindDeliveredInvoices,
  PaginatedInvoice,
} from "contracts/Invoice";
import type { Pagination } from "contracts/Pagination";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess", "onFailure"],
    success: ["data", "pagination"],
    failure: ["errorMessage"],
    softReset: [],
    reset: [],
  },
  {
    prefix: "PAGINATE_DELIVERED_INVOICES_",
  }
);

export interface PaginateDeliveredInvoicesState {
  data: PaginatedInvoice[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginateDeliveredInvoicesRequestAction {
  query?: FindDeliveredInvoices;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: PaginatedInvoice[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginateDeliveredInvoicesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginateDeliveredInvoicesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: PaginateDeliveredInvoicesState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (
  state: PaginateDeliveredInvoicesState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginateDeliveredInvoicesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = (state: PaginateDeliveredInvoicesState) =>
  update(state, {
    data: { $set: {} },
  });

export const paginateDeliveredInvoices = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginateDeliveredInvoicesTypes = Types;
export const PaginateDeliveredInvoicesActions = Creators;
